import { z } from 'zod';

export const loginSchema = (requireTerms: boolean) =>
  z.object({
    email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' }),
    accepted_terms: requireTerms
      ? z
          .boolean({ message: 'You must accept the terms and conditions' })
          .refine((val) => val === true, { message: 'You must accept the terms and conditions' })
      : z.boolean().optional()
  });

export const ssoSchema = () =>
  z.object({
    email: z.string({ message: 'Email is required' }).email({ message: 'Please enter a valid email address' }),
    agency_code: z.string({ message: 'agency code is required' })
  });

export const verifyCodeSchema = z.object({
  code: z
    .string()
    .length(6, { message: 'Code must be exactly 6 digits' })
    .regex(/^\d+$/, { message: 'Code must contain only digits' })
});
